import React from "react";
import { ShieldCheck, Sparkles } from "lucide-react";
import SEO from "@/components/SEO";

export const QUALITY_CHECK_LINE = "Every Star Jewels piece passes a 5-point quality check — covering stone setting, plating & finish, clasp strength, polish, and final packaging inspection — before it reaches you.";

export default function ReturnPolicy() {
  return (
    <main className="mx-auto max-w-3xl px-5 sm:px-10 py-14 sm:py-20" data-testid="return-policy-page">
      <SEO
        title="Return & Exchange Policy"
        description="Star Jewels return and exchange policy — 48-hour exchange window for damaged or defective items, hygiene-first no-returns policy on fashion jewellery."
        path="/return-policy"
      />
      <div className="overline text-center">Care & policy</div>
      <h1 className="font-display text-4xl sm:text-5xl font-light text-center mt-2 leading-tight">Return &amp; Exchange Policy</h1>

      <div className="mt-10 space-y-6 text-sj-inkSoft leading-relaxed">
        <p className="p-5 bg-sj-cream rounded-md flex items-start gap-3">
          <Sparkles size={18} className="text-sj-goldDark mt-0.5 shrink-0" />
          <span className="italic">{QUALITY_CHECK_LINE}</span>
        </p>

        <div>
          <h2 className="font-display text-xl text-sj-ink">General returns</h2>
          <p className="mt-2">Because each piece is inspected before it leaves the boutique, we <strong>do not accept general returns</strong>. We appreciate your understanding — this careful curation is what allows us to keep our pricing warm and our quality high.</p>
        </div>

        <div>
          <h2 className="font-display text-xl text-sj-ink">Exchanges</h2>
          <p className="mt-2">Exchanges are offered <strong>only when a piece arrives damaged or defective</strong>. If that happens, we're truly sorry — and we'll make it right.</p>
          <ul className="mt-3 list-disc pl-5 space-y-1.5">
            <li>Reach out within <strong>48 hours</strong> of delivery via the Moon chat on the site or email us at <strong>officialstarjewels@gmail.com</strong>.</li>
            <li>Share 1–2 clear photos of the damaged item and your order reference.</li>
            <li>Our team reviews every exchange request personally before approval.</li>
          </ul>
        </div>

        <div className="p-5 border border-sj-gold/30 rounded-md flex items-start gap-3">
          <ShieldCheck size={18} className="text-sj-goldDark mt-0.5 shrink-0" />
          <div className="text-sm">
            <div className="font-medium text-sj-ink">Peace of mind</div>
            <p className="mt-1">All exchange approvals are made by the Star Jewels team — never automatically — so you're always speaking to a real person.</p>
          </div>
        </div>
      </div>
    </main>
  );
}
